<template lang="pug">
.add-adult
  .title {{$t('addAdult.title')}}
  .content
    .qr-code(v-if="status === 0")
      .code
        .loading(v-if="qrCode===''")
          .glow  
            round-glow
          .placeholder
        .qr
          img(:src="qrCode")
      .copy
        .instruction  {{$t('addAdult.instruction')}}
        .warning  {{$t('addAdult.warning[0]')}}{{date}}{{$t('addAdult.warning[1]')}}
    .error(v-if="status === 400")
      notification(:status="status" msg="错误" subMsg="服务器连接失败")
  .btn-download(@click="onSave")
    .copy
      .main {{$t('addAdult.download[0]')}}
      .sub  {{$t('addAdult.download[1]')}}
  
</template>
<script>
import SocketService from '@/services/SocketService'
import AlipayService from '@/services/AlipayService'
import RoundGlow from '@/components/wedgits/RoundGlow'
import { mapState } from 'vuex'
import Notification from '@/components/wedgits/Notification'
export default {
  name: 'AddAdult',
  components: { Notification, RoundGlow },
  props: {},
  data() {
    return {
      qrCode: '',
      status: 0,
      date: '',
    }
  },
  computed: {
    ...mapState('app', ['user']),
  },
  methods: {
    onMessage(data) {
      console.log('msg rec inside:', data)
      switch (data.code) {
        case SocketService.Events.ONOPEN: {
          this.onOpen(data.data)
          break
        }
        case SocketService.Events.QR_SCANNED: {
          this.onQRScanned()
          break
        }
      }
    },
    onOpen(data) {
      console.log('on socket open, qr received', data)
      this.qrCode = data.qrCode
    },
    onQRScanned() {
      console.log('qr scanned')
      this.$router.replace('/reservation/addAdult/process')
    },
    onSave() {
      // AlipayService.sendMessage({
      //   msg: AlipayService.Events.SAVE_IMAGE,
      //   url: this.qrCode,
      // })
      AlipayService.sendEvent(AlipayService.Events.SAVE_IMAGE, {
        url: this.qrCode,
      })
    },
    onError() {
      console.log('error!!!!')
      this.status = 400
    },
  },
  mounted() {
    //this.onQRScanned()
    //console.log('QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ')
    let tmr = new Date()
    tmr.setDate(new Date().getDate() + 1)
    let y = tmr.getFullYear()
    let m = tmr.getMonth() + 1
    let d = tmr.getDate()
    //console.log(tmr, y, m, d)
    this.date = `${y}年${m}月${d}日`

    this.socket = SocketService.getInstance()
    this.socket.connect(this.user.id)
    this.socket.on(SocketService.Events.ONMESSAGE, this.onMessage)
    this.socket.on(SocketService.Events.ONERROR, this.onError)
    // setTimeout(() => {
    //   this.$router.replace('/reservation/addAdult/process')
    // }, 2000)
  },
  beforeDestroy() {
    //this.socket.close()
  },
  beforeRouteLeave(to, from, next) {
    if (to.path !== '/reservation/addAdult/process') this.socket.close()
    next()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
.add-adult
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  padding: 0 pxToRem(30)
  color: black
  overflow: hidden
  display: flex
  flex-direction: column
  align-items: center
  justify-content: space-around
  background-image: linear-gradient(-44deg, #0D4EE0 0%, #09A3FD 93%)
  .title
    color: #ffffff
    font-size: pxToRem(56)
    text-align: center
  .content
    width: pxToRem(686)
    height: pxToRem(730)
    border-radius: pxToRem(20)
    background: #ffffff
    position: relative
    .error
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      display: flex
      justify-content: center
      align-items: center
      flex-direction: column
    .qr-code
      width: 100%
      height: 100%
      display: flex
      justify-content: center
      align-items: center
      flex-direction: column
      .code
        width: pxToRem(356)
        height: pxToRem(356)
        position: relative
        .loading
          position: absolute
          width: 100%
          height: 100%
          top: 0
          left: 0
          .glow
            position: relative
            top: -10%
            left: -10%
            width: 120%
            height: 120%
          .placeholder
            position: absolute
            width: 100%
            height: 100%
            top: 0
            left: 0
            background: white
            border-radius: pxToRem(18)
            box-shadow: pxToRem(-5) pxToRem(-5) pxToRem(20) 0 rgba(67,187,255,0.13), pxToRem(7) pxToRem(7) pxToRem(10) 0 rgba(22,139,255,0.16)
      .qr
        width: pxToRem(356)
        height: pxToRem(356)
        overflow: hidden
        img
          position: relative
          width: 100%
          z-index: 10
      .copy
        margin-top: pxToRem(70)
        text-align: center
        .instruction
          color: black
          font-size: pxToRem(30)
          line-height: pxToRem(42)
        .warning
          color: $cl-gray
          line-height: pxToRem(40)
          font-size: pxToRem(28)
  .btn-download
    border: pxToRem(2) #ffffff solid
    padding: pxToRem(21)
    width: pxToRem(560)
    height: pxToRem(120)
    //margin: auto
    .copy
      text-align: center
      .main
        color: #ffffff
        font-size: pxToRem(32)
      .sub
        color: #ffffff
        font-size: pxToRem(24)
        opacity: 0.5
</style>
